export default "__VITE_ASSET__B5itPw$X__"